import type { RevenueSlice, RevenueTrend } from "../types/analyticsDashboard";

export const REVENUE_CHART_COLORS = [
  "#7A76A8",
  "#8E87D6",
  "#B0A6ED",
  "#6E5CE5",
  "#ECEAF7",
  "#9B8FD9",
  "#5B4FCF",
  "#C4B5FD",
] as const;

export const DEFAULT_TREND: RevenueTrend = {
  percent: 0,
  direction: "flat",
  hasComparison: true,
};

export const formatCurrency = (value: number, currency = "EUR") => {
  const code = currency === "MIXED" ? "EUR" : currency;

  return value.toLocaleString("en-US", {
    style: "currency",
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const getRevenuePercent = (value: number, total: number): number => {
  if (total <= 0) {
    return 0;
  }

  return Math.round((value / total) * 100);
};

export const getRevenueTrend = (
  current: number,
  previous: number,
): RevenueTrend => {
  if (previous <= 0) {
    if (current <= 0) {
      return { percent: 0, direction: "flat", hasComparison: true };
    }

    return { percent: 100, direction: "up", hasComparison: false };
  }

  const rawPercent = ((current - previous) / previous) * 100;
  const percent = Math.round(Math.abs(rawPercent) * 10) / 10;

  if (rawPercent > 0) {
    return { percent, direction: "up", hasComparison: true };
  }

  if (rawPercent < 0) {
    return { percent, direction: "down", hasComparison: true };
  }

  return { percent: 0, direction: "flat", hasComparison: true };
};

export function mapToRevenueSlices(
  hotels: Array<{
    hotelId: string;
    hotelName: string;
    totalRevenue: number;
    currency: string;
  }>,
): RevenueSlice[] {
  return hotels.map((hotel, index) => ({
    hotelId: hotel.hotelId,
    name: hotel.hotelName,
    value: hotel.totalRevenue,
    currency: hotel.currency,
    color:
      REVENUE_CHART_COLORS[index % REVENUE_CHART_COLORS.length] ??
      REVENUE_CHART_COLORS[0],
  }));
}
